import React from "react";

const SwapSvg = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Swap</title>
      <path
        d="M3.10251 9.83333L0.666672 7.3975L1.36917 6.67433L2.60267 7.90767V2.95517C2.60267 2.27739 2.84134 1.69983 3.31867 1.2225C3.79601 0.745166 4.37356 0.5065 5.05134 0.5065C5.72912 0.5065 6.30667 0.745166 6.78401 1.2225C7.26134 1.69983 7.50001 2.27739 7.50001 2.95517V7.38467C7.50001 7.78544 7.64123 8.12711 7.92367 8.40967C8.20623 8.69211 8.54789 8.83333 8.94867 8.83333C9.34956 8.83333 9.69123 8.69211 9.97367 8.40967C10.2562 8.12711 10.3975 7.78544 10.3975 7.38467V2.432L9.16417 3.66533L8.46151 2.94233L10.8975 0.5065L13.3333 2.94233L12.6308 3.66533L11.3973 2.432V7.38467C11.3973 8.06244 11.1587 8.64 10.6813 9.11733C10.204 9.59467 9.62645 9.83333 8.94867 9.83333C8.27089 9.83333 7.69334 9.59467 7.21601 9.11733C6.73867 8.64 6.50001 8.06244 6.50001 7.38467V2.95517C6.50001 2.55428 6.35878 2.21261 6.07634 1.93017C5.79378 1.64761 5.45212 1.50633 5.05134 1.50633C4.65045 1.50633 4.30878 1.64761 4.02634 1.93017C3.74378 2.21261 3.60251 2.55428 3.60251 2.95517V7.90767L4.83584 6.67433L5.53851 7.3975L3.10251 9.83333Z"
        fill="#5663F2"
      />
    </svg>
  );
};

export default SwapSvg;
